import React from 'react'

const Dash = () => {
    let width = window.innerWidth
    let heightP = window.innerHeight * 0.09
    let height = window.innerHeight - heightP

    return (
        <div>
            <iframe title="EstoqueAbrace - Estoque" width={width} height={height}
                src="https://app.powerbi.com/view?r=eyJrIjoiNDZkYTM2NzEtOWU4Yi00NmNmLTk3ZGItMjUxNDYxNDJkNzkwIiwidCI6IjNjNjE5YTUwLWM2OGMtNGQ1OC1iMmQ3LWY0NDAyNTYwYWYyYyJ9"
                frameBorder="0" allowFullScreen={true}></iframe>
        </div>
    )
}

export default Dash